import { SR_API_ACTION_APARTMENT_LOCATOR_GET_LEAD } from 'api/actionTypes';

export default async function getLead({ state, apiClient }, renterUserId) {
  await apiClient.postWithState({
    action: SR_API_ACTION_APARTMENT_LOCATOR_GET_LEAD,
    state: state,
    payload: {
      renterUserId: renterUserId,
    },
    onSuccess(lead) {
      state.set(['apartmentLocator', 'lead', 'status'], lead.status);
      state.set(['apartmentLocator', 'lead', 'user'], lead.user);
    },
  });
}
